export default {
    'plainAddress': 'Местоположение',
    'clientName': 'Имя клиента',
    'inn': 'ИНН',
    'orderId': 'Номер заказа',
    'comment': 'Комментарий'
}